// extracted by mini-css-extract-plugin
export default {"root":"TabPanel_root__s-4MA","active":"TabPanel_active__RyRXD","placeHolderShimmer":"TabPanel_placeHolderShimmer__5v+9S"};